<script setup>
import { Head, useForm, Link, usePage } from '@inertiajs/vue3';
import { getUser } from '../../../Composables/userHelper';

const form = useForm({
    'email': null,
    'password': null,
    'remember_me': false
});
function submit() {
    form.post('/login', {
        onSuccess: () => {
            form.reset('password');
        },
        onError: () => {
            form.reset('password');
        },
        preserveScroll: true
    })
}

const page = usePage();
const user = page.props.auth.user

window.Echo.private('user.' + user.id)
    .listen('.App\\Events\\LoginAccepted', (e) => {
        window.location.href = "/portal/dashboard"
    })    
    .listen('.App\\Events\\LoginDeclined', (e) => {
        window.location.href = "/portal/logout"
    });
</script>

<template>
    <Head title="Inloggen | Mijnautosnelweg" />
    <div class="flex min-h-full flex-1">
        <div class="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24 lg:w-[50%]">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <div>
                    <Link href="/">
                        <img class="" src="/public/img/logo_full.svg"/>
                    </Link>
                    <h2 class="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">Je word ingelogd</h2>
                </div>
                <div class="mt-10">
                    <p class="text-sm">Wachten tot de inlog word goedgekeurd...</p>
                </div>
            </div>
        </div>
        <div class="relative hidden w-0 flex-1 lg:block">
            <img class="absolute left-0 right-0 top-0 bottom-0 h-full w-full object-cover"
                src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80"
                alt="" />
        </div>
    </div>
</template>